// Settings module.

export const settings = {
  playerName: "Human Player",
  difficulty: "hard",
  rows: 10,
  columns: 10,
};
